module.exports = __webpack_public_path__ + "static/media/work-castle.923da4ac.svg";